<template>
  <vs-row>
    <vs-col
      vs-type="flex"
      vs-justify="flex-end"
      vs-align="center"
      style="padding: 10px;"
    >
      <vs-button
        color="primary"
        type="filled"
        icon="person_pin"
        size="small"
        @click="loginPrompt = true"
      >
        Авторизация
      </vs-button>

      <vs-prompt
        :active.sync="loginPrompt"
        :is-valid="validCredentials"
        title="Форма авторизации"
        accept-text="Войти"
        cancel-text="Отмена"
        @accept="submitLogin"
        @cancel="credentials.username='',credentials.password=''"
      >
        <div class="prompt-login">
          Для авторизации введите ваши <b>данные</b>.
          <vs-input
            v-model="credentials.username"
            icon-no-border
            icon="account_circle"
            label-placeholder="Логин"
            @keypress.enter="submitLogin"
          />

          <vs-input
            v-model="credentials.password"
            type="password"
            icon-no-border
            icon="lock"
            label-placeholder="Пароль"
            @keypress.enter="submitLogin"
          />

          <vs-alert :active="!validCredentials" color="danger" icon="new_releases">
            Все поля обязательны к заполнению
          </vs-alert>
        </div>
      </vs-prompt>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'Login',
  metaInfo: () => ({
    title: 'Enter Gateway'
  }),
  computed: {
    validCredentials () {
      return !!(this.credentials.username.length && this.credentials.password.length)
    }
  },
  data: () => ({
    credentials: {
      username: '',
      password: ''
    },
    loginPrompt: false
  }),
  methods: {
    async submitLogin () {
      try {
        if (!this.validCredentials)
          return false

        this.loginPrompt = false

        this.$vs.loading()
        const { username, password } = this.credentials

        await this.$auth.login({
          data: { username, password },
          rememberMe: false
        })

        this.$vs.loading.close()

      } catch (err) {
        this.credentials = {
          username: '',
          password: ''
        }
        this.$vs.loading.close()
      }
    }
  }
}
</script>

<style lang="stylus">
.login-card
  max-width 320px
  margin 100px auto 0

.prompt-login
  padding 10px
  padding-bottom 0;

  .vs-input
    width 100%
    padding-top 5px

  .con-vs-alert
    margin-top 10px
</style>